var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"inline-block fill-current",attrs:{"aria-hidden":"true","viewBox":"0 0 324 146","focusable":"false"}},[_c('path',{attrs:{"d":"M50.241 146.142c121.073 0 173.233.131 224.152 0 27.054-56.282 49.871-107.417 49.871-107.417l.129-11.78-50-26.945L50.241.83l-50 26.115L0 38.725z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }